import type { RaceConfig } from '../../types/config.ts';
import type { SourceStripItem } from '../../lib/reconcile.ts';
import { candidateName } from '../../lib/candidates.ts';
import { fmtTimeOfDay } from '../../lib/time.ts';

/** Compact "other sources" row: each source's leader + margin + % reporting, so
 *  no source is hidden behind the primary. */
export function MultiSourceStrip({ race, items }: { race: RaceConfig; items: SourceStripItem[] }) {
  if (!items.length) return null;
  return (
    <div className="strip">
      <p className="strip__label">Other sources</p>
      <ul className="strip__list">
        {items.map((it) => (
          <li key={it.sourceId} className="strip__item">
            <span className="strip__src">{it.label}</span>
            <span className="strip__margin tabular">
              {it.margin.leaderId
                ? `${candidateName(race, it.margin.leaderId)} +${
                    it.margin.marginPct != null ? it.margin.marginPct.toFixed(1) : '—'
                  }`
                : '—'}
            </span>
            <span className="strip__rep dim tabular">
              {it.margin.reportingPercent != null ? `${it.margin.reportingPercent.toFixed(0)}% rep.` : ''}
            </span>
            <span className="strip__time dim">as of {fmtTimeOfDay(it.fetchedAt)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
